import { OptionalLink } from "@/components/OptionalLink";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle
} from "@/components/ui/card";
import { MessageSquareQuote } from "lucide-react";
import { cn } from "@/lib/utils";

interface TestimonialProps {
  image?: string;
  name: string;
  userName?: string;
  comment: string;
  link?: string;
}

const testimonials: TestimonialProps[] = [
  {
    name: "ProductHunt",
    link: "https://www.producthunt.com/products/dollardeploy/reviews",
    comment:
      "Cool and fast way to deploy your app on any server. Their service is quite solid already."
  },
  {
    name: "Ryan",
    comment: "I am a new customer and the experience was great so far."
  },
  {
    name: "Dhruv",
    comment:
      "I really like the simplicity, UI and UX. Please add more tools with a single click deploy."
  }
];

export const Testimonials = ({ landing = false }: { landing?: boolean }) => {
  return (
    <section
      id="testimonials"
      className={cn(landing ? "container" : "col-span-full", "text-center")}
    >
      <h2 className="text-3xl md:text-4xl font-bold mb-8">
        Some feedback from our
        <span className="gradient-light dark:gradient-dark"> early users.</span>
      </h2>

      <div className="flex flex-col md:grid grid-cols-3 gap-4">
        {testimonials.map(
          ({ image, name, userName, comment, link }: TestimonialProps, index) => (
            <OptionalLink href={link} key={index}>
              <Card className="flex flex-col gap-2 border rounded-lg h-full hover:bg-muted/50">
                <CardHeader className="flex flex-row items-center gap-4 pb-2">
                  {image && (
                    <Avatar>
                      <AvatarImage alt="" src={image} />
                      <AvatarFallback>OM</AvatarFallback>
                    </Avatar>
                  )}

                  <div className="flex flex-col text-left">
                    <CardTitle className="text-xl flex items-center gap-2">
                      <MessageSquareQuote /> {name}
                    </CardTitle>
                    {userName && <CardDescription>{userName}</CardDescription>}
                  </div>
                </CardHeader>

                <CardContent className="text-left">{comment}</CardContent>
              </Card>
            </OptionalLink>
          )
        )}
      </div>
    </section>
  );
};
